export const environment = {
  firebase: {
  },
  VAPIDKEY: '',
  google_api_key: '',
  routes_api_key: '',
  production: true,
  version: '0.0.1 (beta)',
  graphql_endpoint: 'https://api.p2p-staging.storexweb.team/graphql',
  url: 'https://files.p2p-staging.storexweb.team/',
  places_key: '',
  skip_auth: false,
  STRIP_KEY:"",
  stripReturnUrl: '',
};

